module.exports = __webpack_public_path__ + "static/media/PATS_4-1018w.5c59bc3d.webp";